module.exports = __webpack_public_path__ + "img/vip.e881d069.png";